import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import { Button } from "react-bootstrap";
import { Errors } from 'react-redux-form';
import Icon from "../../../../icon";
import { InputFieldFloatingLabel as InputField, 
         SelectFieldFloatingLabel as Select, 
         SelectFieldFloatingLabel_Ranking as SelectRanking } from '../../../../common/custom-form/select-filter.component';
import CustomSearchableSelectWrapper from '../../../../common/custom-form/custom-searchable-select-wrapper.component';
import DATEPICKER_OR from '../../../../common/custom-form/custom-date-picker.component';
import DateRange from '../../../../common/custom-form/custom-date-range-component';
import { CustomDropdown } from '../../../../common/custom-form/custom-dropdown.component';
import AddressDetails from '../../../inventory/DetailsView/add-address.component';
import UserDetailsInfo from '../../../../external/inventory/modal/user-details-modal';
import { ConfirmationModal } from "../../../../common/modal/modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { ACTION_TYPES, Selected_Index, CIRCUIT_SIM_RANK, MAX_LENGTH, DATA_TYPE, ORDER_STATUS, REQUEST_TYPES_ID, WIRELINE_REQUEST_TYPES_ID } from '../../../../../constants/external-constants'
import Translation from '../../../../common/translation/translation.component';
import { TRANSLATIONS as translation, CIRCUIT_STATUS } from '../../../../../utils/constant.utils';
import AddEquipment from '../../../inventory/DetailsView/add-equipment/add-equipment.component';
import AddSim from '../../../inventory/DetailsView/add-sim/add-sim.component';
import AddPlanDetails from '../../../inventory/DetailsView/add-plan-details.component';
import AddCostAllocation from '../../../inventory/DetailsView/add-cost-allocation.component';
import { areDataEqual, isDisabledPerRequestType, isObjectEqual } from '../../../../../utils/helpers.utils';
import { circuitOrderActions } from '../../../../../store/external/order/order-circuit.reducer';
import { NoSubscription } from '../../../dashboard/no-subscription/no-subscription.component';
import { addPlanDetailActions } from "../../../../../store/external/inventory/details-view/add-plan-details.reducer";
import { inventoryCircuitSimActions } from "../../../../../store/external/inventory/details-view/add-sim.reducer";
import { inventoryCircuitEquipActions } from "../../../../../store/external/reports-reducer/inventory/details-view/add-equipment.reducer";
import { inventoryCostAllocationActions } from "../../../../../store/external/inventory/add-cost-allocation.reducer";
import { sideNavMenuActions } from '../../../../../store/external/side-nav-menu-reducer/side-nav-menu.reducer';
import { Loading } from "../../../../common/loading";
import { pipInformationActions } from "../../../../../store/external/inventory/details-view/pip-information.reducer";
import { accessInformationActions } from "../../../../../store/external/inventory/details-view/access-information.reducer";
import PIPInformation from "../../../inventory/DetailsView/pip-information.component";
import AccessInformation from "../../../inventory/DetailsView/access-information.component";
import CustomSearchableDropdownWrapper from "../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";
class OrderCircuit extends Component {
    constructor(props){
        super(props)
        this.ConfirmationModal = React.createRef();
        this.state = {
            circuitId: 0,
            circuitOrderId: 0,
            orderCircuitDetailId: 0,
            orderId: 0,
            selectedCircuit: 0,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            addCostChange: false,
            isSaving: false,
            proceedSaveModal: false,
            inputValue: "",
            installDate: "",
            selectedIndex: "0",
            showSimDetails: false,
            showEquipmentDetails: false,
            showPlanDetails: false,
            showTakeActionModal: false,
            showTakeAction: false,
            showCostAllocationDetails: false,
            simChange: false,
            equipmentChange:false,
            updatePlanDetails: false,
            updateSimDetails: false,
            updateCostAllocationDetails: false,
            updateEquipmentDetails: false,
            planDetailsChange:false,
            pendingApproval: false,
            modalType: '',
            showConfModal: true,
            activeDropdown: null,
            orderHistorySelected: false,
            isInService: false,
            loading: true,
            inProgress: true,
            mrcValue: "0.00",
            planId: 0,
            fileList: [],
            dropDownFields:{
                circuitTypeID: null,
                subCircuitTypeID: null,
                linkedCircuitID: null,
                billingAccountID: null
            },
            takeActionItem: [],
            listTabInfo: {
                Tab: [
                    {
                        "id": Selected_Index.i_Zero,
                        "label": "Details",
                        "hidden": false
                    },
                    {
                        "id": Selected_Index.i_One,
                        "label": "Usage Spend",
                        "hidden": false
                    },
                    {
                        "id": Selected_Index.i_Two,
                        "label": "Linked Circuits",
                        "hidden": false
                    },
                    {
                        "id": Selected_Index.i_Three,
                        "label": "Invoice",
                        "hidden": false
                    },                    
                    {
                        "id": Selected_Index.i_Four,
                        "label": "Comments",
                        "hidden": false
                    },
                    {
                        "id": Selected_Index.i_Five,
                        "label": "History",
                        "hidden": false
                    }
                ]
            },
            historyTabInfo: {
                Tab: [
                    {
                        "id": "0",
                        "label": "Circuit History"
                    },
                    {
                        "id": "1",
                        "label": "Order History"
                    }
                ]
            },           
            pages: {
                "PageNumber": 0,
                "PerPage": 10,
                "TotalPages": 2,
                "TotalEntries": 11,
                "HasNext": true,
                "HasPrevious": false,
                "PageSizes": [
                    10,
                    20,
                    30
                ]
            },
            originalVendorID: 0,
            originalCircuitTypeID: 0,
            originalPlanDetails: {
                "datatable": []
            },
            updateEquipmentListStatus: false,
            originalData: {} ,
            originalSimData: {},
            originalPlanData: {},
            originalEquipmentData: {},
            originalCostAllocationData: {},
            simTableLength: 0,
            costAllocationTableLength: 0,
            equipmentTableLength: 0,
            orderPlanTableLength: 0,
            planDetailsUpdated: false,
            accessInfo: {},
            pipInfo: {}
        };
    }

    async componentDidMount() {       
        const { orderDetailsId, requestTypeId, getCircuitOrder, ranking, getOrderLocation } = this.props;
        var circuitOrder = await getCircuitOrder(orderDetailsId, requestTypeId, false, true, ranking);
        await getOrderLocation();
        await this.props.getCircuitOrderAllLocations1(1, circuitOrder?.LocationAddress?.DeliveryAddress);
        await this.props.getCircuitOrderAllLocations2(1, circuitOrder?.LocationP2P?.DeliveryAddress);
        this.setState({ 
            circuitId: parseInt(requestTypeId) === parseInt(WIRELINE_REQUEST_TYPES_ID.newSubscriptionWireline) || circuitOrder.CircuitId === null ? 0 : circuitOrder.CircuitId
            ,circuitOrderId: circuitOrder.CircuitOrderId 
            , orderId: circuitOrder.OrderId
            , orderCircuitDetailId: circuitOrder.OrderCircuitDetailId
            , originalCircuitTypeID: circuitOrder.CircuitTypeId
            , originalVendorID: circuitOrder.VendorID
        });
        this.fetchData(circuitOrder.CircuitId, circuitOrder.VendorID, this.state.selectedCircuit, circuitOrder.OrderCircuitDetailId);
    }

    async componentWillUnmount() {
        const { resetCircuitSimForm, resetCircuitSimDetails, resetCircuitOrderForm, clearSelectedUser } = this.props;
        resetCircuitSimForm();
        resetCircuitSimDetails();
        resetCircuitOrderForm();
        clearSelectedUser();
    }

    componentDidUpdate(prevProps) {
        if(this.props.circuitOrderForm.circuitOrderDetails.monthlyRateCharge !== prevProps.circuitOrderForm.circuitOrderDetails.monthlyRateCharge) {
            this.setState({
                mrcValue: this.props.circuitOrderForm.circuitOrderDetails.monthlyRateCharge
            });
        }

        if (parseInt(this.state.originalCircuitTypeID) === 0
            && this.props.circuitOrderForm.circuitOrderDetails.circuitTypeID !== prevProps.circuitOrderForm.circuitOrderDetails.circuitTypeID)
        {
            this.setState({
                originalCircuitTypeID: this.props.circuitOrderForm.circuitOrderDetails.circuitTypeID
            });

        }
        if (parseInt(this.state.originalVendorID) === 0
            && this.props.circuitOrderForm.circuitOrderDetails.vendorID !== prevProps.circuitOrderForm.circuitOrderDetails.vendorID)
        {
            this.setState({
                originalVendorID: this.props.circuitOrderForm.circuitOrderDetails.vendorID
            });
        }

        if (parseInt(this.state.originalPlanDetails?.datatable?.length) === 0
            && this.props.inventoryCircuitPlanDetails?.planDetails?.datatable?.length > 0)
        {
            this.setState({
                originalPlanDetails: {
                    "datatable": this.props.inventoryCircuitPlanDetails?.planDetails?.datatable
                }
            });
        }
    }

    async fetchData(circuitId, vendorId, selectedCircuit, orderCircuitDetailId) {
        window.scrollTo(0, 0);
        //<!-- Add Cost Allocation
        await this.props.getCircuitOrderAddCostAllocation(this.props.orderDetailsId, this.props.requestTypeId, orderCircuitDetailId).then(() => {
            const { circuitCostAllocation } = this.props.inventoryCostAllocation;
            const tableLength = circuitCostAllocation?.datatable[0]?.dataItem?.length;
            const originalCostAlloDataCopy = JSON.parse(JSON.stringify(this.props.inventoryCostAllocation));
            this.setState({ originalCostAllocationData: originalCostAlloDataCopy, costAllocationTableLength: tableLength })
        });

        //<!-- Add Sim Details
        await this.props.getCircuitOrderSimList(this.props.orderDetailsId, this.props.requestTypeId, orderCircuitDetailId).then(() => {
            const { circuitSimList } = this.props.inventoryCircuitSIM;
            const tableLength = circuitSimList?.datatable[0]?.dataItem?.length;
            const originalSimDataCopy = JSON.parse(JSON.stringify(this.props.inventoryCircuitSIM));
            this.setState({ originalSimData: originalSimDataCopy, simTableLength: tableLength })
            
        })

        //<!-- Add Equipment
        const { orderDetailsId, requestTypeId, getCircuitOrder, ranking, circuitOrderForm } = this.props;
        var circuitOrder = await getCircuitOrder(orderDetailsId, requestTypeId, false, false, ranking);
        await this.props.getCircuitOrderEquipList(vendorId, orderDetailsId, requestTypeId, orderCircuitDetailId, circuitOrderForm.circuitOrderDetails.circuitTypeID).then(() => {
            const { circuitEquipList } = this.props.inventoryCircuitEquip;
            const tableLength  = circuitEquipList?.datatable && 
            Array.isArray(circuitEquipList.datatable) && 
            circuitEquipList.datatable[0]?.dataItem 
            ? circuitEquipList.datatable[0].dataItem.length 
            : 0;
            const originalEquipmentDataCopy = JSON.parse(JSON.stringify(this.props.inventoryCircuitEquip));
            this.setState({ originalEquipmentData: originalEquipmentDataCopy, equipmentTableLength: tableLength })
        })


        if (Object.values(WIRELINE_REQUEST_TYPES_ID).includes(requestTypeId)) {
            //<-- Access/PIP Information
            await this.props.getOrderCircuitAccessInformationDetails("circuitOrderAccessForm", this.props.orderDetailsId, requestTypeId, orderCircuitDetailId);
            await this.props.getOrderCircuitPIPInformationDetails("circuitOrderPipForm", this.props.orderDetailsId, requestTypeId, orderCircuitDetailId);
        } 
        //<-- Add Plan Details
        await this.props.getCircuitOrderPlanDetails(circuitOrder.RequestTypeId, orderDetailsId, orderCircuitDetailId).then(() => {
            const originalPlanDataCopy = JSON.parse(JSON.stringify(this.props.inventoryCircuitPlanDetails));
            this.setState({ originalPlanData: originalPlanDataCopy })
        });
        if (circuitId) {
            const { planDetails } = this.props.inventoryCircuitPlanDetails;
            const planId = planDetails?.datatable[0]?.dataItem[0]?.PlanId ?? 0;

            this.props.getInventoryCircuitPlanComponents(planId);

            this.setState({ planId: planId });
        }
        this.setState({ loading: false })
    }

    convertToDecimal = (value) =>{
        if(typeof value === "string") return value;

        const result = (Math.round(value * 100) / 100).toFixed(2);

        return result;
    }

    ShowCostAllocationDetails(value) {
        this.setState({ showCostAllocationDetails: value })
    }

    handelToggleDropdown = (index, isShow = false) => {
        this.setState(prevState => ({
            activeDropdown: prevState.activeDropdown === index && !isShow ? null : index
        }));
    }

    handleChangesStatus = (prop, truthValue) =>{
        this.setState({
            [prop]: truthValue
        })
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (!locale || !translation[locale]){
            return translation[translation['defaultLocaleLanguage']][key];
        }

        return translation[locale][key];
    }

    onChangeDates = (dates) => {
        const [start, end] = dates;

        this.props.selectDate('circuitOrderForm.circuitOrderDetails.suspensionFromDate', start);
        this.props.selectDate('circuitOrderForm.circuitOrderDetails.suspensionToDate', end);
    };

    onChangeCircuitTypeSelection(e) {
        const { circuitOrderForm } = this.props;

        if (parseInt(e) !== parseInt(circuitOrderForm?.circuitOrderDetails?.circuitTypeID)) {
            this.props.selectCircuitTypeID();

            if (circuitOrderForm.circuitOrderDetails.vendorID != null) {
                this.props.getInventoryPlanTypesByVendorByCircuitTypeAsync(circuitOrderForm?.circuitOrderDetails?.vendorID, e, 1, '');
            }
            else {
                this.props.getInventoryPlanTypesByVendorByCircuitTypeAsync(0, e, 1, '');
            }

            if ((parseInt(this.state.originalCircuitTypeID) !== parseInt(e)
                || parseInt(this.state.originalVendorID) !== parseInt(circuitOrderForm?.circuitOrderDetails?.vendorID))
                && this.state.circuitId > 0
                && this.props.inventoryCircuitPlanDetails?.planDetails?.datatable?.length > 0)
            {
                this.props.deletePlanDetails();
            }

            if ((parseInt(this.state.originalCircuitTypeID) === parseInt(e)
                && parseInt(this.state.originalVendorID) === parseInt(circuitOrderForm?.circuitOrderDetails?.vendorID))
                && this.state.circuitId > 0
                && this.state.originalPlanDetails.datatable.length > 0)
            {
                this.props.inventoryCircuitPlanDetails.planDetails.datatable = this.state.originalPlanDetails.datatable;
            }

            if (parseInt(e) !== parseInt(circuitOrderForm?.circuitOrderDetails?.circuitTypeID) && circuitOrderForm?.circuitOrderDetails?.vendorID > 0) {
                this.props.GetlinkCircuitsByVendorIdAndCircuitTypeId(this.state.circuitId, e, circuitOrderForm.circuitOrderDetails.vendorID, 1, '');
            }
        }
    } 

    updateEquipmentListStatus = (item, index, arr) => {
        if (parseInt(arr[index].StatusId) === parseInt(CIRCUIT_STATUS.inService.id)) {
            arr[index].StatusId = parseInt(this.props.circuitOrderForm.circuitOrderDetails.statusID);
        }
    }

    onChangeBillingAccountSelection(e) {
        const { circuitOrderForm, selectBillingAccountID, circuitOrder,resetBillingDetails,requestTypeId } = this.props;
        const { circuitOrderDetails } = circuitOrderForm;
        if (e !=null && e != circuitOrderForm.circuitOrderDetails.billingAccountID) {
            selectBillingAccountID(e, requestTypeId);
            var filterBilling = circuitOrder.CircuitOrderAllAccountDetailsDropdown.filter(r => parseInt(r.BillingAccountID) === parseInt(e));
            var vendorID = filterBilling.length > 0 ? filterBilling[0].VendorDetailID : 0;
            if (circuitOrderForm?.circuitOrderDetails?.circuitTypeID != null && vendorID !== undefined) {
                this.props.getInventoryPlanTypesByVendorByCircuitTypeAsync(vendorID, circuitOrderDetails.circuitTypeID, 1, '');
            }
            else {
                this.props.getInventoryPlanTypesByVendorByCircuitTypeAsync(0, 0, 1, '');
            }

            if ((parseInt(this.state.originalCircuitTypeID) !== parseInt(circuitOrderForm?.circuitOrderDetails?.circuitTypeID)
                || parseInt(this.state.originalVendorID) !== parseInt(vendorID))
                && this.state.circuitId > 0
                && this.props.inventoryCircuitPlanDetails?.planDetails?.datatable?.length > 0)
            {
                this.props.deletePlanDetails();
            }

            if ((parseInt(this.state.originalCircuitTypeID) === parseInt(circuitOrderForm?.circuitOrderDetails?.circuitTypeID)
                && parseInt(this.state.originalVendorID) === parseInt(vendorID))
                && this.state.circuitId > 0
                && this.state.originalPlanDetails.datatable.length > 0)
            {
                this.props.inventoryCircuitPlanDetails.planDetails.datatable = this.state.originalPlanDetails.datatable;
            }

            if (parseInt(this.state.originalCircuitTypeID) !== parseInt(circuitOrderForm?.circuitOrderDetails?.circuitTypeID))
            {
                this.props.GetlinkCircuitsByVendorIdAndCircuitTypeId(this.state.circuitId, circuitOrderForm.circuitOrderDetails.circuitTypeID, circuitOrderForm.circuitOrderDetails.vendorID, 1, '');
            }
        } else {
            resetBillingDetails(requestTypeId);
        }
        
    }

    handleSaveCircuitDetails = async (confirmSavePropName = null, validate = 1) => {
        const { saveCircuitOrderDetails, circuitOrderForm, inventoryCircuitEquip, $form, orderDetailsId, requestTypeId } = this.props;
        const { circuitId, orderCircuitDetailId } = this.state;

        if (parseInt($form.loadedValue?.circuitOrderDetails?.statusID) === parseInt(CIRCUIT_STATUS.inService.id) && parseInt(circuitOrderForm?.circuitOrderDetails?.statusID) !== parseInt(CIRCUIT_STATUS.inService.id)
            && inventoryCircuitEquip.circuitEquipList.datatable.length > 0
            && inventoryCircuitEquip.circuitEquipList.datatable[0].dataItem.length > 0
            && this.state.updateEquipmentListStatus === true) {
            inventoryCircuitEquip.circuitEquipList.datatable[0].dataItem.forEach(this.updateEquipmentListStatus);
        } else {
            this.setState({
                updateEquipmentListStatus: false
            });
        }

        this.setState({
            isSaving: true
        })

        var result = await saveCircuitOrderDetails(requestTypeId, orderDetailsId, circuitId, confirmSavePropName, validate, orderCircuitDetailId);
       
        this.setState({
            isSaving: false
        });
        const isNew = parseInt(this.state.orderId) === 0;
        if (result.success === false) {
            if (result.confirmProceed) {
                var confirmAction = () => this.handleSaveCircuitDetails(result.propertyName, isNew ? 0 : 1);
                this.toggleSaveModal(true, this.toLocaleLanguage("modal_error_title"), result.message, confirmAction);
                return;
            }
            else if (result.isValid) {
                if (isNew === false) {

                    if ($form.loadedValue?.circuitOrderDetails.statusID == CIRCUIT_STATUS.inService.id && parseInt(circuitOrderForm.circuitOrderDetails.statusID) != CIRCUIT_STATUS.inService.id) {

                        if (inventoryCircuitEquip.circuitEquipList.datatable.length > 0
                            && inventoryCircuitEquip.circuitEquipList.datatable[0].dataItem.length > 0) {
                            this.setState({
                                updateEquipmentListStatus: true
                            });
                        }

                        const confirmMessage = this.toLocaleLanguage("save_circuit_updatingStatus_confirmation");
                        const modalTitle = this.toLocaleLanguage("update");
                        var confirmActions = () => this.handleSaveCircuitDetails(null, 0);
                        this.toggleSaveModal(true, modalTitle, confirmMessage, confirmActions);
                        return;

                    }
                    else {
                        const confirmMessage = this.toLocaleLanguage("update_circuit_confirmation");
                        const modalTitle = this.toLocaleLanguage("update");
                        var confirmAction = () => this.handleSaveCircuitDetails(null, 0);
                        this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                        return;
                    }
                }
                else {
                    this.handleSaveCircuitDetails(null, 0);
                    return;
                }
            }
            else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title"), result.message,result);
                return;
            }
        }
        else if (result.success === true) {
            const successMessage = isNew ? this.toLocaleLanguage("new_order_circuit_message") : this.toLocaleLanguage("update_circuit_message");
            this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title"), successMessage,result);              
        }

        this.toggleSaveModal(false);

        return;
    }

    handleChangesStatusPlan = (prop, truthValue, mrc, planUpdated) => {
        this.props.updateCircuitMRC(mrc);
        this.setState({
            [prop]: truthValue,
            planDetailsUpdated: planUpdated
        })
    }

    handleNotifcation= () => {        
        const { circuitId } = this.state;
        var result= this.state.saveNotif.result;
        var isNewCircuit = parseInt(circuitId) === 0;
        if (result.success === true) {

            const { getCircuitOrderEquipList, circuitOrderForm } = this.props;
            const { circuitOrderDetails } = circuitOrderForm;

            if (this.state.updateEquipmentListStatus == true && !isNewCircuit) {
                getCircuitOrderEquipList();
            }

            this.props.FormLoad('circuitOrderForm', circuitOrderForm);
           
            this.setState({
                originalCircuitTypeID: circuitOrderForm.circuitOrderDetails.circuitTypeID,
                originalVendorID: circuitOrderForm.circuitOrderDetails.vendorID,
                originalPlanDetails: {
                    "datatable": this.props.inventoryCircuitPlanDetails.planDetails.datatable
                },
                updateEquipmentListStatus: false
            });  
            this.setState({ inProgress: true });
            this.fetchData(this.state.circuitId, circuitOrderDetails.vendorID ?? 0, this.state.selectedCircuit, this.state.orderCircuitDetailId).then(()=>{
                this.setState({ inProgress: false });
            }); 
        }
    }

    handleCloseNotif = () => {
        this.toggleSaveNotif(false);
        this.handleNotifcation();
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    toggleSaveNotif = (isShow, title, message,result) => {
        const { saveNotif } = this.state;
        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
                result: result ?? ""
            }
        });

        if (!isShow && saveNotif.message === this.toLocaleLanguage("new_circuit_message")) {
            this.CloseForm();
            this.props.getInventoryCircuit();
        }
    }

    statusDisableSave = () => {
        const { requestTypeId } = this.props;
        const { circuitOrderDetails } = this.props.circuitOrderForm

        if (parseInt(circuitOrderDetails.orderStatusID) === parseInt(ORDER_STATUS.canceled)
            || parseInt(circuitOrderDetails.orderStatusID) === parseInt(ORDER_STATUS.rejected)
            || parseInt(circuitOrderDetails.orderStatusID) === parseInt(ORDER_STATUS.completed)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.subscriptionCancellation)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.portOut)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.intlRoamingAccess)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.CallingAccess)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.terminateSubscriptionWireline)) {
            return true;
        }
        else {
            return false;
        }
    }


    disableSaveChanges = () => {
         
            const { circuitOrderForm, circuitOrderInventoryCircuitSIM, circuitOrderInventoryCircuitPlanDetails,
                circuitOrderInventoryCircuitEquip, circuitOrderInventoryCostAllocation, $form, 
                requestTypeId, circuitOrderAccessForm, circuitOrderPipForm, circuitOrder } = this.props;

            const { circuitOrderDetails } = circuitOrderForm;
            
            const removePrimarySecondaryConf=(obj,props) => {
                const newObj = { ...obj };
                props.forEach(prop => delete newObj[prop]);
                return newObj;
            }

            const excludedProps = ['primarySecondaryConfirmation','circuitCodeConfirmation'];

            const cleanData = (obj) => {
                
                const clonedObj = JSON.parse(JSON.stringify(obj));
              
                if (clonedObj.circuitOrderDetails) {
                    clonedObj.circuitOrderDetails = removePrimarySecondaryConf(
                    clonedObj.circuitOrderDetails,
                    excludedProps
                  );
                }
              
                return clonedObj;
              };

            const normalizeValue = (val) => {
                if (val === null || val === undefined) return '';
                if (typeof val === 'number') return val;
                return val;
            };

            const normalizeObject = (obj) => {
                if (obj === null || obj === undefined) return '';
                if (typeof obj !== 'object') return normalizeValue(obj);
                if (Array.isArray(obj)) return obj.map(normalizeObject);

                const normalized = {};
                for (const key in obj) {
                    if (Object.hasOwn(obj, key)) {
                        normalized[key] = normalizeObject(obj[key]);
                    }
                }
                return normalized;
            };

            const unchangedCircuitOrderDetails = !$form.loadedValue ? true : isObjectEqual(normalizeObject(cleanData($form.loadedValue).circuitOrderDetails), normalizeObject(cleanData(circuitOrderForm).circuitOrderDetails));

            const unchangedOrderLocation1 = !$form.loadedValue ? true : isObjectEqual(normalizeObject($form.loadedValue.circuitOrderLocation1), normalizeObject(circuitOrderForm.circuitOrderLocation1));

            const unchangedOrderLocation2 = !$form.loadedValue ? true : isObjectEqual(normalizeObject($form.loadedValue.circuitOrderLocation2), normalizeObject(circuitOrderForm.circuitOrderLocation2));

            const unchangeAccess = isObjectEqual(this.state.accessInfo, circuitOrderAccessForm)
            const unchangePip = isObjectEqual(this.state.pipInfo, circuitOrderPipForm)

            const circuitSimDetails = circuitOrderInventoryCircuitSIM?.circuitSimList?.datatable?.length > 0
                ? areDataEqual(this.state.originalSimData.circuitSimList.datatable[0].dataItem, circuitOrderInventoryCircuitSIM.circuitSimList.datatable[0].dataItem)
                : true;
        
            const circuitPlanDetails = circuitOrderInventoryCircuitPlanDetails?.planDetails?.datatable[0]?.dataItem?.length > 0
                ? areDataEqual(this.state.originalPlanData.planDetails.datatable[0].dataItem, circuitOrderInventoryCircuitPlanDetails.planDetails.datatable[0].dataItem)
                : true;

            const circuitEquipDetails = circuitOrderInventoryCircuitEquip?.circuitEquipList?.datatable?.length > 0
                ? areDataEqual(this.state.originalEquipmentData.circuitEquipList.datatable[0].dataItem, circuitOrderInventoryCircuitEquip.circuitEquipList.datatable[0].dataItem)
                : true;

            const circuitCostAllocationDetails = circuitOrderInventoryCostAllocation?.circuitCostAllocation?.datatable?.length > 0
                ? areDataEqual(this.state.originalCostAllocationData.circuitCostAllocation.datatable[0].dataItem, circuitOrderInventoryCostAllocation.circuitCostAllocation.datatable[0].dataItem)
                : true;

                let initialRequired
 
            if (requestTypeId === REQUEST_TYPES_ID.changeVendor) {
                initialRequired = circuitOrderDetails.billingAccountID != 0 && circuitOrderDetails.billingAccountID != null
                    && circuitOrderDetails.billingAccountID != ''
                    && circuitOrder.CircuitOrderAllAccountDetailsDropdown?.some((item) => item.BillingAccountID === circuitOrderDetails.billingAccountID)
                    && circuitOrderInventoryCircuitPlanDetails?.planDetails?.datatable[0]?.dataItem?.length > 0;
            }
            else if (requestTypeId === REQUEST_TYPES_ID.newSubscriptionWireline || requestTypeId === REQUEST_TYPES_ID.wirelineChangeVendor || requestTypeId === REQUEST_TYPES_ID.updatePlanWireline) {
                initialRequired = circuitOrderDetails.circuitCode != '' && circuitOrderDetails.circuitCode != null
                    && circuitOrderDetails.circuitTypeID != 0 && circuitOrderDetails.circuitTypeID != '' && circuitOrderDetails.monthlyRateCharge != ''
                    && circuitOrderDetails.billingAccountID != 0 && circuitOrderDetails.billingAccountID != null && circuitOrderDetails.billingAccountID != ''
                    && circuitOrderDetails.primarySecondary != null;
            }
            else {
                initialRequired = circuitOrderDetails.circuitCode != '' && circuitOrderDetails.circuitCode != null
                    && circuitOrderDetails.circuitTypeID != 0 && circuitOrderDetails.circuitTypeID != '' && circuitOrderDetails.monthlyRateCharge != ''
                    && circuitOrderDetails.billingAccountID != 0 && circuitOrderDetails.billingAccountID != null && circuitOrderDetails.billingAccountID != ''
                    && circuitOrderDetails.primarySecondary != null;
            }

            let checkAccessAndPIP

            if (Object.values(WIRELINE_REQUEST_TYPES_ID).includes(requestTypeId)) {
                checkAccessAndPIP = unchangeAccess && unchangePip;
            }
            else {
                checkAccessAndPIP = true;
            }

        return !initialRequired || (unchangedOrderLocation1 && unchangedOrderLocation2 && unchangedCircuitOrderDetails && checkAccessAndPIP && circuitSimDetails && circuitPlanDetails && circuitEquipDetails && circuitCostAllocationDetails);

    };

    handleOnClearOption = () => {
        const { selectLocation, circuitOrderForm } = this.props;
        if (circuitOrderForm.circuitOrderLocation1.locationID == "") {
            selectLocation('.circuitOrderLocation1.locationID', 0)
        }
        if (circuitOrderForm.circuitOrderLocation2.locationID == "") {
            selectLocation('.circuitOrderLocation2.locationID', 0)
        }
    }

    isOrderStatusCompleted = () => {
        const { orderDetailsForm } = this.props;
        return orderDetailsForm?.orderStatus === "Completed";
    }

    fetchAccessData = (value) => {
        this.setState({
            accessInfo: value
        })
    }

    fetchPipData = (value) => {
        this.setState({
            pipInfo: value
        })
    }

    handleLocationSearch = (query) => {
        this.props.getOrderLocation(1, query);
    }

    loadMoreLocation = (searchString) => {
        const { circuitOrder } = this.props;
        this.props.getOrderLocation(circuitOrder?.locationPage + 1, searchString);
    }
    handleSubCircuitTypeSearch = (query) => {
        const { circuitOrderForm} = this.props;
        const { circuitOrderDetails } = circuitOrderForm;
        this.props.getCircuitOrderSubCircuitTypes(circuitOrderDetails?.circuitTypeID, 1, query);
    }

    loadMoreSubCircuitType = (searchString) => {
        const { circuitOrder, circuitOrderForm } = this.props;
        const { circuitOrderDetails } = circuitOrderForm;
        this.props.getCircuitOrderSubCircuitTypes(circuitOrderDetails?.circuitTypeID, circuitOrder?.subCircuitTypePage + 1, searchString);
    }
    handleEmployeeSearch = (query) => {
        this.props.getCircuitOrderAllEmployees(1, query);
    }

    loadMoreEmployees = (searchString) => {
        const { circuitOrder } = this.props;
        this.props.getCircuitOrderAllEmployees(circuitOrder?.employeePage + 1, searchString);
    }

    handleBillingAccountSearch = (query) => {
        const { circuitOrderForm } = this.props;
        const { circuitOrderDetails } = circuitOrderForm;
        this.props.getCircuitOrderAllAccountDetails(circuitOrderDetails?.vendorID, 1, query);
    }

    loadMoreBillingAccount = (searchString) => {
        const { circuitOrder, circuitOrderForm } = this.props;
        const { circuitOrderDetails } = circuitOrderForm;
        this.props.getCircuitOrderAllAccountDetails(circuitOrderDetails?.vendorID, circuitOrder?.billingAccountPage + 1, searchString);
    }
    handleLocation1Search = (query) => {
        this.props.getCircuitOrderAllLocations1(1, query);
    }

    loadMoreLocation1 = (searchString) => {
        const { circuitOrder } = this.props;
        this.props.getCircuitOrderAllLocations1(circuitOrder.location1Page + 1, searchString);
    }
    handleLocation2Search = (query) => {
        this.props.getCircuitOrderAllLocations2(1, query);
    }

    loadMoreLocation2 = (searchString) => {
        const { circuitOrder } = this.props;
        this.props.getCircuitOrderAllLocations2(circuitOrder.location2Page + 1, searchString);
    }
    handleLinkedCircuitsSearch = (query) => {
        const { circuitOrderForm } = this.props;
        const { circuitOrderDetails } = circuitOrderForm;

        const {
            circuitId,
        } = this.state;

        this.props.GetlinkCircuitsByVendorIdAndCircuitTypeId(circuitId, circuitOrderDetails?.circuitTypeID, circuitOrderDetails?.vendorID, 1, query);
    }

    loadMoreLinkedCircuits = (searchString) => {
        const { circuitOrderForm, circuitOrder } = this.props;
        const { circuitOrderDetails } = circuitOrderForm;

        const {
            circuitId,
        } = this.state;
        this.props.GetlinkCircuitsByVendorIdAndCircuitTypeId(circuitId, circuitOrderDetails?.circuitTypeID, circuitOrderDetails?.vendorID, circuitOrder.linkedCircuitsPage + 1, searchString);
    }

    handleGlCodeSearch = (query) => {
        this.props.getOrderCircuitGlCodeListDropdown(1, query);
    };

    loadMoreGlCode = (searchString) => {
        const { circuitOrder } = this.props;
        this.props.getOrderCircuitGlCodeListDropdown(circuitOrder.glCodePage + 1, searchString);
    };
    handleCostCenterSearch = (query) => {
        this.props.getOrderCircuitCostCenterListDropdown(1, query);
    };

    loadMoreCostCenter = (searchString) => {
        const { circuitOrder } = this.props;
        this.props.getOrderCircuitCostCenterListDropdown(circuitOrder.costCodePage + 1, searchString);
    };
    render() {

        const { circuitOrder, circuitOrderForm, selectUserHRID, requestTypeId, orderDetailsId, isReadAndWrite } = this.props;
        const { circuitOrderDetails, circuitOrderLocation1, circuitOrderLocation2 } = circuitOrderForm;
        var circuitId = circuitOrder.CircuitId ?? 0;
        var orderId = circuitOrder.OrderId ?? 0;
        let vendorId = circuitOrderDetails.vendorID ?? 0;
        let circuitTypeID = circuitOrderDetails.circuitTypeID ?? 0;
        let billingAccountID = circuitOrderDetails.billingAccountID ?? 0;
        this.handleOnClearOption();
        const link_primary_circuit_disabled = circuitOrderDetails.primarySecondary === CIRCUIT_SIM_RANK.Secondary ? false : true;

        const other_equipment = parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.other)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeNumber)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.simActivation)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.enableHotspot)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.suspendResumeService)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.pukCode)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherSIMReplacement)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherChangeOfPlan)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeVendor);

        const requiredPrimarySecondary = parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.newMobile)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.simAndDevice)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.newMobileDevice)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.wifiDongleAndDataCard)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.simAndDeviceBSA)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.simOnlyBSA)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.multiSIMBSA)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.wifiDongleAndDataCardBIN)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.voiceSIMBIN)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.wifiDongleDataCardAndVoiceSIMBIN)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.portIn);

        const isRequestRequired = parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.other)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeNumber)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.enableHotspot)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.suspendResumeService)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.simActivation)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.pukCode)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherSIMReplacement)
            || parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.otherChangeOfPlan);

        const isUnableToDeletePlan = parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.changeVendor);

        if (this.state.loading) {
            return <Loading />
        }
        var statusDisableSave = this.statusDisableSave();
        
        return (
            <>
            {circuitOrder.fetchingCircuitOrder

                ? <NoSubscription /> :
                    
                <div className="order-circuit-container inventory-details-field-container">
                <div className="details-container date-picker-main-container">
                    <div className="details-field-container">
                        <div className="detail-with-icon-container">
                                {(this.state.isInService
                                    &&
                                    (this.props.isReadOnly
                                    || this.props.isReadAndExtractOnly
                                    || this.props.isReadAndWrite)
                                )
                                    &&
                            <Icon
                                name="ellipsis"
                                size="18px"
                                customClassName="icon-nav"
                                containerClass="info-container"
                                onClick={this.handleShowTakeAction.bind(this)}
                                />}
                            <div className={`create-request-children ${this.state.showTakeAction ? 'Active' : ""}`}>
                                <span>{`${this.toLocaleLanguage('actions_capital')}`}</span>

                                {this.state.takeActionItem?.map((list, index) =>
                                    <span key={index} className="take-action-list" onClick={() => this.handleTakeActionModal(list.RequestTypeID, list.RequestType)}>{list.RequestType}</span>
                                )}
                            </div>
                            <InputField
                                className={`form-control ${isDisabledPerRequestType(requestTypeId, 'circuitCode') ? '' : 'required'}`}
                                type="text"
                                label={`${this.toLocaleLanguage('circuit_id_capital')}`}
                                value={circuitOrderDetails?.circuitCode}
                                fieldProp='circuitOrderForm.circuitOrderDetails.circuitCode'
                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'circuitCode')}
                            />
                        </div>
                        <Select
                            className={`form-select ${isRequestRequired ? 'required' : ''}`}
                            label={`${this.toLocaleLanguage('status_capital')}`}
                            value={circuitOrderDetails?.statusID}
                            options={circuitOrder.circuitOrderStatusDropdown}
                            placeholder={isDisabledPerRequestType(requestTypeId, 'statusID') ? '' : `${this.toLocaleLanguage('select_placeholder')}`}
                            fieldProp='circuitOrderForm.circuitOrderDetails.statusID'
                            disabled={this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'statusID')}
                        />

                        <CustomSearchableSelectWrapper
                            label={`${this.toLocaleLanguage('circuit_type_capital')}`}
                            options={circuitOrder.CircuitOrderCircuitTypesByCategoryDropdown}
                            selected={circuitOrderDetails?.circuitTypeID}
                            placeholder={isDisabledPerRequestType(requestTypeId, 'circuitTypeID') ? '' : `${this.toLocaleLanguage('select_placeholder')}`}
                            onChange={(e) => this.onChangeCircuitTypeSelection(e)}
                            requiredField={!isDisabledPerRequestType(requestTypeId, 'circuitTypeID')}
                            fieldProp='circuitOrderForm.circuitOrderDetails.circuitTypeID'
                            tagName='circuitTypeID'
                            optionLabelKey={{
                                Key: 'Key',
                                Value: 'Value'
                                }}
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'circuitTypeID')}
                        />
                        
                        <CustomSearchableDropdownWrapper
                        label={`${this.toLocaleLanguage('sub_circuit_type_capital')}`}
                        options={circuitOrder.CircuitOrderSubCircuitTypesDropdown}
                        selected={circuitOrderDetails?.subCircuitTypeID}
                        placeholder={isDisabledPerRequestType(requestTypeId, 'subCircuitTypeID') ? '' : `${this.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='circuitOrderForm.circuitOrderDetails.subCircuitTypeID'
                        tagName='subCircuitTypeID'
                        optionLabelKey={{
                            Key: 'Key',
                            Value: 'Value'
                        }}
                        maxLength={MAX_LENGTH.limit_100}
                        disabled={this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'subCircuitTypeID')}
                        onSearchChange={this.handleSubCircuitTypeSearch}
                        onLoadMore={this.loadMoreSubCircuitType}
                        isLoading={circuitOrder.isSubCircuitTypeLoading}
                        hasMore={circuitOrder.hasMoreSubCircuitType}
                        />
                        <InputField
                                className={`form-control ${isDisabledPerRequestType(requestTypeId, 'monthlyRateCharge') ? '' : 'required'}`}
                                type="text"
                                label={`${this.toLocaleLanguage('mrc')}`}                           
                                value={this.convertToDecimal(circuitOrderDetails?.monthlyRateCharge)}                                           
                                fieldProp='circuitOrderForm.circuitOrderDetails.monthlyRateCharge'
                                placeholder={isDisabledPerRequestType(requestTypeId, 'monthlyRateCharge') ? '' : `${this.toLocaleLanguage('enter_text_placeholder')}`}
                                inputType={DATA_TYPE.decimal}
                                maxLength={MAX_LENGTH.inputText}
                                disabled={this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'monthlyRateCharge')}
                         />
                        <InputField
                            className="form-control"
                            type="text"
                            label={`${this.toLocaleLanguage('currency_capital')}`}
                            value={circuitOrderDetails?.currency}
                            fieldProp='circuitOrderForm.circuitOrderDetails.currency'
                            disabled={isDisabledPerRequestType(requestTypeId, 'currency')}

                        />
                        <SelectRanking
                            className={`form-select ${requiredPrimarySecondary || isRequestRequired ? 'required' : ''}`}
                            label={`${this.toLocaleLanguage('circuit_ranking_capital')}`}
                            value={circuitOrderDetails?.primarySecondary}
                            options={circuitOrder.CircuitOrderAllCircuitRankingsDropdown}
                            placeholder={isDisabledPerRequestType(requestTypeId, 'primarySecondary') ? '' : `${this.toLocaleLanguage('select_placeholder')}`}
                            fieldProp='circuitOrderForm.circuitOrderDetails.primarySecondary'
                            onChangeAction={this.props?.selectCircuitRank}
                            disabled={this.isOrderStatusCompleted() ||isDisabledPerRequestType(requestTypeId, 'primarySecondary')}
                         />

                        <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('link_primary_circuit_capital')}`}
                                options={circuitOrder.CircuitOrderLinkedCircuitsOptions}
                                selected={circuitOrderDetails?.primarySecondary === CIRCUIT_SIM_RANK.Primary ? null : circuitOrderDetails?.linkedCircuitID}
                                fieldProp='circuitOrderForm.circuitOrderDetails.linkedCircuitID'
                                placeholder={!isDisabledPerRequestType(requestTypeId, 'linkedCircuitID') && !link_primary_circuit_disabled? this.toLocaleLanguage('select_placeholder') : null}
                                maxLength={MAX_LENGTH.limit_100}
                                isNullable={true}
                                tagName='linkedCircuitID'
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                    }}
                                disabled={link_primary_circuit_disabled || this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'linkedCircuitID')}
                                onSearchChange={this.handleLinkedCircuitsSearch}
                                onLoadMore={this.loadMoreLinkedCircuits}
                                isLoading={circuitOrder.isLinkedCircuitsLoading}
                                hasMore={circuitOrder.hasMoreLinkedCircuits}

                        />
                        <div className="detail-with-icon-container">
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('billing_account_capital')}`}
                                options={circuitOrder.CircuitOrderAllAccountDetailsDropdown}
                                selected={circuitOrderDetails?.billingAccountID}
                                onChange={(e) => this.onChangeBillingAccountSelection(e)}
                                requiredField={!isDisabledPerRequestType(requestTypeId, 'billingAccountID')}
                                placeholder={isDisabledPerRequestType(requestTypeId, 'billingAccountID') ? '' :`${this.toLocaleLanguage('select_placeholder')}`}
                                fieldProp='circuitOrderForm.circuitOrderDetails.billingAccountID'
                                tagName='billingAccountID'
                                maxLength={MAX_LENGTH.limit_100}
                                optionLabelKey={{
                                    Key: 'BillingAccountID',
                                    Value: 'BillingAccount'
                                        }}
                                disabled={this.isOrderStatusCompleted()  || isDisabledPerRequestType(requestTypeId, 'billingAccountID')}
                                onSearchChange={this.handleBillingAccountSearch}
                                onLoadMore={this.loadMoreBillingAccount}
                                isLoading={circuitOrder.isBillingAccountLoading}
                                hasMore={circuitOrder.hasMoreBillingAccount}
                                />
                        </div>
                        <InputField
                            className="form-control"
                            type="text"
                            label={`${this.toLocaleLanguage('account_type_capital')}`}
                            value={circuitOrderDetails?.financeAccountTypeName}
                            fieldProp='circuitOrderForm.circuitOrderDetails.financeAccountTypeName'
                            disabled={isDisabledPerRequestType(requestTypeId, 'financeAccountTypeName')}

                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={`${this.toLocaleLanguage('client_capital')}`}
                            value={circuitOrderDetails?.clientName}
                            fieldProp='circuitOrderForm.circuitOrderDetails.clientName'
                            disabled={isDisabledPerRequestType(requestTypeId, 'clientName')}

                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={`${this.toLocaleLanguage('vendor_capital')}`}
                            value={circuitOrderDetails?.vendor}
                            fieldProp='circuitOrderForm.circuitOrderDetails.vendor'
                            disabled={isDisabledPerRequestType(requestTypeId, 'vendor')}

                        />
                        <div className="detail-with-icon-container">
                            {
                                circuitOrderForm.endUserID > 0 &&
                                <UserDetailsInfo title="User Details" 
                                    userDetails={circuitOrder?.inventoryUserHrDetails} 
                                    selectedUser={circuitOrderDetails?.endUserID} 
                                    costAllocationData={this.state.dataTable} 
                                    circuitData={this.state.dataTable}
                                    endUserID={circuitOrderDetails?.endUserID}
                                    // locale = {locale}
                                />
                                }
                                <CustomSearchableDropdownWrapper
                                    label={`${this.toLocaleLanguage('user_hr_id_capital')}`}
                                    options={circuitOrder.CircuitOrderAllEmployeesDropdown}
                                    selected={circuitOrderDetails?.endUserID}
                                    onChange={selectUserHRID}
                                    placeholder={isDisabledPerRequestType(requestTypeId, 'endUserID') ? '' : `${this.toLocaleLanguage('select_placeholder')}`}
                                    fieldProp='circuitOrderForm.circuitOrderDetails.endUserID'
                                    tagName='circuitOrderDetails.endUserID'                                               
                                    optionLabelKey={{
                                        Key: 'EmployeeID',
                                        Value: 'Idhr'
                                    }}
                                    requiredField={isRequestRequired}
                                    maxLength={MAX_LENGTH.limit_100}    
                                    disabled={this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'endUserID')}
                                    onSearchChange={this.handleEmployeeSearch}
                                    onLoadMore={this.loadMoreEmployees}
                                    isLoading={circuitOrder.isEmployeeLoading}
                                    hasMore={circuitOrder.hasMoreEmployees}              
                                />
                        </div>
                        <InputField
                            className="form-control"
                            type="text"
                            label={`${this.toLocaleLanguage('user_name_capital')}`}
                            value={circuitOrderDetails?.userName}
                            fieldProp='circuitOrderForm.circuitOrderDetails.userName'
                            disabled={isDisabledPerRequestType(requestTypeId, 'userName')}
                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={`${this.toLocaleLanguage('email_address_capital')}`}
                            value={circuitOrderDetails?.emailAddress}
                            fieldProp='circuitOrderForm.circuitOrderDetails.emailAddress'
                            disabled={isDisabledPerRequestType(requestTypeId, 'emailAddress')}
                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={`${this.toLocaleLanguage('line_manager_capital')}`}
                            value={circuitOrderDetails?.lineManager}
                            fieldProp='circuitOrderForm.circuitOrderDetails.lineManager'
                            disabled={isDisabledPerRequestType(requestTypeId, 'lineManager')}
                        />
                    
                        <DATEPICKER_OR 
                            dateOnly={true} 
                            label={`${this.toLocaleLanguage('install_date_capital')}`} 
                            placeholder={`${this.toLocaleLanguage('select_date')}`} 
                            startDate={circuitOrderDetails?.installDate} 
                            selectedDate={(date) => this.props?.selectDate("circuitOrderForm.circuitOrderDetails.installDate", date)} 
                            isDisable={this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'installDate')}
                        />
                        <DATEPICKER_OR 
                            dateOnly={true} 
                            label={`${this.toLocaleLanguage('disconnect_date_capital')}`} 
                            placeholder={`${this.toLocaleLanguage('select_date')}`} 
                            startDate={circuitOrderDetails?.disconnectDate} 
                            selectedDate={(date) => this.props?.selectDate("circuitOrderForm.circuitOrderDetails.disconnectDate", date)}                            
                            isDisable={this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'disconnectDate')}
                        />
                        <DateRange 
                            dateOnly={true} 
                            label={`${this.toLocaleLanguage('suspension_date_capital')}`} 
                            placeholder={`${this.toLocaleLanguage('select_date')}`} 
                            startDate={circuitOrderDetails?.suspensionFromDate} 
                            endDate={circuitOrderDetails?.suspensionToDate} 
                            dateSelected={circuitOrderDetails?.suspensionFromDate} 
                            isDisable={this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'suspensionDate')}
                            onChange={this.onChangeDates} />
                    </div>
                    <div className="horizontal-separator"></div>
                            <CustomDropdown label={<Translation translationKey={"location_address_1"} />} isActive={this.state.activeDropdown === Selected_Index.i_Zero} onToggle={() => this.handelToggleDropdown(Selected_Index.i_Zero)}>
                            <div className= "add-sim-container">
                                
                                    <AddressDetails 
                                        completed={this.isOrderStatusCompleted()} 
                                        requestTypeId={requestTypeId} 
                                        locationDetails={circuitOrderLocation1} 
                                        translator={(x) => this.toLocaleLanguage(x)} 
                                        inventoryAllLocations={circuitOrder?.inventoryAllLocations1} 
                                        circuitKey="circuitLocationAddress" 
                                        fieldProp="circuitOrderForm.circuitOrderLocation1" 
                                        formName="circuitOrderForm" 
                                        onChangeAction={this.props.selectLocation} 
                                        isCircuitOrder={true}  
                                        loadMoreLocation={this.loadMoreLocation1}
                                        handleLocationSearch={this.handleLocation1Search}
                                        hasMoreLocation={circuitOrder.hasMoreLocation1}
                                        isLocationLoading={circuitOrder.isLocation1Loading}
                                    />        
                            </div>
                    </CustomDropdown>
                            <CustomDropdown label={<Translation translationKey={"location_address_2"} />}isActive={this.state.activeDropdown === Selected_Index.i_One} onToggle={() => this.handelToggleDropdown(Selected_Index.i_One)}>
                            <div className= "add-sim-container">
                                    <AddressDetails 
                                        completed={this.isOrderStatusCompleted()} 
                                        requestTypeId={requestTypeId} 
                                        locationDetails={circuitOrderLocation2} 
                                        translator={(x) => this.toLocaleLanguage(x)} 
                                        inventoryAllLocations={circuitOrder?.inventoryAllLocations2} 
                                        circuitKey="circuitLocationP2P" 
                                        fieldProp="circuitOrderForm.circuitOrderLocation2" 
                                        formName="circuitOrderForm" 
                                        onChangeAction={this.props.selectLocation} 
                                        isCircuitOrder={true} 
                                        loadMoreLocation={this.loadMoreLocation2}
                                        handleLocationSearch={this.handleLocation2Search}
                                        hasMoreLocation={circuitOrder.hasMoreLocation2}
                                        isLocationLoading={circuitOrder.isLocation2Loading}
                                    />
                            </div>
                            </CustomDropdown>        
                            {
                                Object.values(WIRELINE_REQUEST_TYPES_ID).includes(requestTypeId)  &&
                                <>
                                    <AccessInformation
                                        //Access Type
                                        circuitId={circuitId}
                                        {...this.props.roles}
                                        requestTypeId={requestTypeId}
                                        disableField={this.disableField}
                                        formModel="circuitOrderAccessForm" 
                                        formName="circuitOrderForm"
                                        isInventoryCircuit={false}
                                        OrderCircuitDetailId = {this.state.orderCircuitDetailId}
                                        fetchAccessData = {this.fetchAccessData}
                                        completed={this.isOrderStatusCompleted()}
                                    />

                                    <PIPInformation
                                        //Access Type
                                        circuitId={circuitId}
                                        {...this.props.roles}
                                        requestTypeId={requestTypeId}
                                        disableField={this.disableField}
                                        formModel="circuitOrderPipForm" 
                                        formName="circuitOrderForm"
                                        isInventoryCircuit={false}
                                        OrderCircuitDetailId = {this.state.orderCircuitDetailId}
                                        fetchPipData = {this.fetchPipData}
                                        completed={this.isOrderStatusCompleted()}
                                    />

                                </>
                            }                             
                        <AddPlanDetails
                            //Access Type
                                {...this.props.roles}
                                handleChangesStatus={this.handleChangesStatusPlan}
                                hasPendingApproval={this.state.pendingApproval}
                                isDisable={this.isOrderStatusCompleted() || isDisabledPerRequestType(requestTypeId, 'AddPlanDetails')}
                                hideDeleteBtn={isUnableToDeletePlan || isDisabledPerRequestType(requestTypeId, 'AddPlanDetails')}
                                requestTypeId={requestTypeId}
                                isCircuitOrder={true}
                                circuitId={circuitId}
                                circuitTypeId={circuitOrderDetails.circuitTypeID}
                                vendorId={vendorId}
                                orderDetailsId={orderDetailsId}
                                orderPlanTableLength={this.orderPlanTableLength}
                                OrderCircuitDetailId = {this.state.orderCircuitDetailId}
                                completed={this.isOrderStatusCompleted()}
                        />
                        <Errors model="circuitOrderForm.circuitSIMs" className="has-error" />
                            <AddSim 
                                circuitId={circuitId}
                                toggleDropdown={this.handelToggleDropdown}
                                activeDropdown={this.state.activeDropdown}
                                completed={this.isOrderStatusCompleted()}
                                //Access Type
                                {...this.props.roles}
                                translator={(x) => this.toLocaleLanguage(x)}
                                handleChangesStatus={this.handleChangesStatus}
                                hasPendingApproval={this.state.pendingApproval}
                                disableField={this.disableField}
                                requestTypeId={requestTypeId}
                                isCircuitOrder={true}
                                orderDetailsId={orderDetailsId}
                                simTableLength={this.state.simTableLength}
                                OrderCircuitDetailId = {this.state.orderCircuitDetailId}
                            />
                        <AddEquipment
                                circuitId={circuitId}
                                toggleDropdown={other_equipment ? this.handelToggleDropdown : false}
                                activeDropdown={false}
                                statusValue={circuitOrderDetails?.statusID}
                                isCircuitOrder={true}
                                completed={this.isOrderStatusCompleted()}
                                //Access Type
                                {...this.props.roles}
                                translator={(x) => this.toLocaleLanguage(x)}
                                handleChangesStatus={this.handleChangesStatus}
                                hasPendingApproval={this.state.pendingApproval}
                                vendorId={vendorId}
                                circuitTypeID={circuitTypeID}
                                billingAccountID={billingAccountID}
                                orderId={orderId}
                                isDisable={other_equipment ? false : true}
                                hideDeleteBtn={other_equipment ? false : true}
                                disableField={this.disableField}
                                requestTypeId={requestTypeId}
                                orderDetailsId={orderDetailsId}
                                equipmentTableLength={this.state.equipmentTableLength}
                                OrderCircuitDetailId = {this.state.orderCircuitDetailId}
                        />

                        <Errors model="circuitOrderForm.circuitCostAllocations" className="has-error" />
                        <div className="control-container">                                      
                            <AddCostAllocation
                                    circuitId={circuitId}
                                    titleBtn={this.state.updateCostAllocationDetails ? ACTION_TYPES.Update : ACTION_TYPES.Add}
                                    showDetails={this.ShowCostAllocationDetails.bind(this)}
                                    toggleDropdown={this.handelToggleDropdown}
                                    activeDropdown={this.state.activeDropdown}
                                    toggleActiveState={this.toggleActiveState}
                                    inventoryCircuit={circuitOrder}
                                    glcodeOptions={circuitOrder?.circuitGlCodeList}
                                    costcenterOptions={circuitOrder?.circuitCostCenterList}
                                    completed={this.isOrderStatusCompleted()}
                                    //Access Type
                                    {...this.props.roles}
                                    translator={(x) => this.toLocaleLanguage(x)}
                                    handleChangesStatus={this.handleChangesStatus}
                                    hasPendingApproval={this.state.pendingApproval}
                                    disableField={this.disableField}
                                    requestTypeId={requestTypeId}
                                    isCircuitOrder={true}
                                    orderDetailsId={orderDetailsId}
                                    costAllocationTableLength={this.state.costAllocationTableLength}
                                    OrderCircuitDetailId={this.state.orderCircuitDetailId}
                                    handleGlCodeSearch={this.handleGlCodeSearch}
                                    loadMoreGlCode={this.loadMoreGlCode}
                                    isGLCodeLoading={circuitOrder.isGLCodeLoading}
                                    hasMoreGLCode={circuitOrder.hasMoreGLCode}
                                    handleCostCenterSearch={this.handleCostCenterSearch}
                                    loadMoreCostCenter={this.loadMoreCostCenter}
                                    isCostCenterLoading={circuitOrder.isCostCodeLoading}
                                    hasMoreCostCenter={circuitOrder.hasMoreCostCode}  
                                />
                        </div>
                </div>
                {
                    this.state.pendingApproval ?
                        <span className="pending-approval-message">Note: This circuit is still under an order workflow, users are restricted to save any changes</span>
                        :
                            <div className="save-btn-container">

                                <ConfirmationModal
                                    customClass="no-border"
                                    ref={this.ConfirmationModal}
                                    title={this.state.saveModal.title}
                                    messageBody={this.state.saveModal.messageBody}
                                    confirmAction={this.state.saveModal.confirmAction}
                                    closeLabel={this.toLocaleLanguage("cancel_button")}
                                    confirmLabel={this.toLocaleLanguage("yes_button")}
                                    disabled={this.state.isSaving}
                                />
                                
                                <NotificationModal
                                    show={this.state.saveNotif.show}
                                    title={this.state.saveNotif.title}
                                    message={this.state.saveNotif.message}
                                    handleModal={this.handleCloseNotif}
                                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                                    />
                                   
                                <div className="tooltip-container">
                                    <div className="btn-tooltiptext">
                                            {isReadAndWrite ? !statusDisableSave &&
                                                <Button disabled={this.disableSaveChanges()} onClick={() => this.handleSaveCircuitDetails()} className="save-details-btn">
                                                    Save Circuit
                                                </Button>
                                                : null
                                            }
                                        <div className="save-tooltip-text-container">
                                            <span className="tooltip-text-save">{<Translation translationKey="save_changes_on_the_circuit" />}</span>
                                        </div>
                                    </div>
                                </div>
                        </div>
                            }

                        </div>
                
                }
                </>
            
        );
    }
}


export default connect(
    state => {
        const { circuitOrder, inventoryCircuitPlanDetails, inventoryCircuitSIM, inventoryCircuitEquip, inventoryCostAllocation, translation } = state;
        const { circuitOrderInventoryCircuitPlanDetails, circuitOrderInventoryCircuitSIM, circuitOrderInventoryCircuitEquip, circuitOrderInventoryCostAllocation } = state;
        const { circuitOrderForm, circuitOrderAccessForm, circuitOrderPipForm, orderDetailsForm, inventoryUserDetails, 
            inventoryCicuitPlanDetailsForm, forms: { circuitOrderForm: { $form } } } = state.form;
        return {
            circuitOrder
            ,circuitOrderForm
            ,circuitOrderPipForm
            ,circuitOrderAccessForm
            ,orderDetailsForm
            ,inventoryUserDetails
            ,inventoryCicuitPlanDetailsForm
            ,inventoryCircuitPlanDetails
            ,inventoryCircuitSIM
            ,inventoryCircuitEquip
            ,inventoryCostAllocation
            , $form
            , circuitOrderInventoryCircuitPlanDetails
            , circuitOrderInventoryCircuitSIM
            , circuitOrderInventoryCircuitEquip
            , circuitOrderInventoryCostAllocation
            , ...translation
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}
                ,circuitOrderActions
                ,sideNavMenuActions
                ,addPlanDetailActions
                ,inventoryCircuitSimActions
                ,inventoryCircuitEquipActions
                , inventoryCostAllocationActions
                , pipInformationActions
                ,accessInformationActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(OrderCircuit);